export const loadFallback = () => {
  return (
    <div className="h-screen tw-w-screen flex flex-col tw-gap-4 justify-center items-center">
      <span className="tw-text-secondary tw-text-xl tw-font-bold">Loading...</span>
    </div>
  )
}
